import {Component, OnInit, ViewChild} from '@angular/core';
import {ConstantsService} from "../ConstantsService";
import {FormFormasEntregaComponent} from "../../superadmin/form-formasdeentrega/form-formasdeentrega.component";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ActivatedRoute} from "@angular/router";
import {TabStripComponent} from "@progress/kendo-angular-layout";

@Component({
  selector: 'app-tela-config-empresa',
  templateUrl: './tela-config-empresa.component.html',
  styleUrls: ['./tela-config-empresa.component.scss']
})
export class TelaConfigEmpresaComponent implements OnInit {
  @ViewChild('tabstrip', { static: false }) private tabstrip: TabStripComponent;
  @ViewChild('tabHorarios', { static: false }) private tabHorarios: TabStripComponent;
  @ViewChild('frmFormaEntrega') frmFormaEntrega: FormFormasEntregaComponent;
  @ViewChild('appFotos') appFotos: any;
  empresa: any;
  usuario: any;
  salvando: boolean;
  mensagemSucesso: any;
  agora: Date;
  fusos = [{ descricao: 'UTC -02:00 (Fernando Noronha Time - FNT)', valor: -2},
    { descricao: 'UTC -03:00 (Brasília Time - BRT)', valor: -3 },
    { descricao: 'UTC -04:00 (Amazonas Time - AMT)', valor: -4 },
    { descricao: 'UTC -05:00 (Acre Time - ACT)', valor: -5 }
  ];
  fusoHorario: any;
  nomeTabFormasPagamento = 'Formas de Pagamento';
  nomeTabHorario = 'Horários';
  nomeTabImpressao = 'Impressão';
  nomeTabKeeta = 'Integração com Keeta'
  nomeTabIfood = 'Integração com Ifood'
  nomeTab99Food = 'Integração com 99Food'
  possuiModuloFiscal: boolean;
  possuiModuloKDS: boolean;
  constructor(private constantsService: ConstantsService, private autorizacaoService: AutorizacaoService,
              private  activatedRoute: ActivatedRoute,
              private empresasService: EmpresasService) {
    this.agora = new Date();

  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser();

    this.constantsService.moduloFiscal$.subscribe(possui => { this.possuiModuloFiscal = possui });
    this.constantsService.possuiModuloKDS$.subscribe(possui => { this.possuiModuloKDS = possui ;
       if(this.possuiModuloKDS) this.nomeTabImpressao = `${this.nomeTabImpressao} / KDS`

    });

    this.constantsService.empresa$.subscribe( empresa => {
      if(empresa){
        this.empresa = empresa;
        this.setFusoEmpresa();
        setTimeout( () => {
          if(this.frmFormaEntrega) this.frmFormaEntrega.exibaFormasEmpresa();

          let nometab: any = this.activatedRoute.snapshot.params.nometab;
          let formapagamento = this.activatedRoute.snapshot.params.formapagamento;
          let parceiro = this.activatedRoute.snapshot.params.parceiro;

           if(nometab === 'pausasprogramadas')
             return this.exibaAbaPausasProgramadas();

           if(nometab === 'impressao')
             return this.exibaAbaImpressao();

          if(nometab === 'keeta')
            return   this.exibaAba(this.nomeTabKeeta)

          if(nometab === 'ifood')
            return this.exibaAba(this.nomeTabIfood)

          if(nometab === '99food')
            return this.exibaAba(this.nomeTab99Food)

          if(formapagamento) this.exibaFormapagamentoOnline()

          if(parceiro) this.exibaAbaIntegracaoParceiro(parceiro)

          }, 0)
      }

    });

  }

  exibaFormapagamentoOnline(meiopagamento: string = 'pagarme'){
    //meiopagamento === 'pagarme'

    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tabFormasPagamento: any = tabs.find((_tab: any) => _tab.title ===  this.nomeTabFormasPagamento);

    if (tabFormasPagamento)
      this.tabstrip.selectTab(tabs.indexOf(tabFormasPagamento))
  }

  exibaAbaPausasProgramadas(){

    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tab: any = tabs.find((_tab: any) => _tab.title ===  this.nomeTabHorario);

    if (tab){
      this.tabstrip.selectTab(tabs.indexOf(tab))

      setTimeout(() => {
          //exibir  Pausa Programada
           this.tabHorarios.selectTab(1)
      }, 100)
    }
  }

  exibaAba(nome: string){
    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tab: any = tabs.find((_tab: any) => _tab.title === nome  );

    if (tab){
      this.tabstrip.selectTab(tabs.indexOf(tab))

      setTimeout(() => {
        //exibir  Pausa Programada
        this.tabHorarios.selectTab(1)
      }, 100)
    }
  }

  exibaAbaKeeta(){

  }

  exibaAbaImpressao(){
    this.exibaAba(this.nomeTabImpressao)
  }

  exibaAbaIntegracaoParceiro(parceiro: string){
    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tabFormasPagamento: any = tabs.find((_tab: any) => _tab.title.toUpperCase().indexOf(parceiro.toUpperCase()) >= 0);

    if (tabFormasPagamento)
      this.tabstrip.selectTab(tabs.indexOf(tabFormasPagamento))
  }

  moduloAtivo(nome: string) {
    if(!this.empresa) return false;

    return this.empresa.modulos.find( modulo => modulo.nome === nome) != null;
  }



  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }


  private setFusoEmpresa() {
    this.fusoHorario = this.fusos.find( fuso => fuso.valor === this.empresa.fusoHorario);
  }


  selecionouFuso() {

    this.empresasService.atualizeFusoHorario(this.empresa, this.fusoHorario.valor).then( () => {
      this.empresa.fusoHorario = this.fusoHorario.valor;
    }).catch((err) => {
      this.setFusoEmpresa();
      alert(err)
    })
  }
}
